import React, {useEffect, useState} from "react";
import {Button, Card, CardBody, Typography,} from "@material-tailwind/react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import Footer from "./footer";
import {XCircle} from "lucide-react";

function Error() {
    const navigate = useNavigate();
    const [branch, setBranch] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const getAddress = async () => {
        //localStorage.clear();
        try {
            await axios
                .get(process.env.REACT_APP_API_URL + "/api/v1/getAddress", {
                    withCredentials: true,
                })
                .then((response) => {
                    setBranch(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    //navigate("/");
                });
        } catch (e) {
            console.log(e);
        }

        document.cookie = `Authorization=;expires=;path=`; //얘약하고 하면 쿠키 자동 삭제. 다시 예약 시도하지 못하도록 막음.
    };

    useEffect(() => {
        getAddress();
    }, []);

    function handleClick() {
        navigate("/");
    }

    return (
        <>
            <div className="min-h-screen bg-gradient-to-br from-red-50 to-gray-50">
                <div className="container mx-auto max-w-7xl px-4 py-4 sm:py-6">
                    {/* Enhanced Header */}
                    <div className="mb-6 sm:mb-8">
                        <div className="flex items-center justify-center mb-4 sm:mb-6">
                            <div>
                                <Typography variant="h4" color="blue-gray"
                                            className="font-bold text-xl sm:text-2xl lg:text-3xl text-center">
                                    Reservation Failed
                                </Typography>
                                <Typography variant="paragraph" color="gray" className="mt-1 text-sm sm:text-base text-center">
                                    Your booking could not be completed
                                </Typography>
                            </div>
                        </div>

                        {/* Progress indicator */}
                        <div className="flex items-center justify-center mb-6 sm:mb-8 overflow-x-auto px-2 sm:px-4 overflow-y-hidden">
                            <div className="flex items-center justify-center w-full max-w-3xl">
                                {/* Step 1 - Select Services */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-400 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <XCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            1. Services
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 1 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-gray-400 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 2 - Choose Schedule */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-400 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <XCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            2. Schedule
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 2 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-gray-400 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 3 - Car Information */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-400 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <XCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            3. Car
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 3 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-gray-400 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 4 - Contact Information */}
                                <div className="flex items-center min-w-max justify-center">
                                    <div className="flex items-center">
                                        <div
                                            className="w-6 h-6 sm:w-6 sm:h-6 md:w-8 md:h-8 bg-gray-400 text-white rounded-full flex items-center justify-center text-xs sm:text-sm flex-shrink-0"
                                        >
                                            <XCircle className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"/>
                                        </div>
                                        <Typography variant="small"
                                                    className="ml-1 sm:ml-2 text-gray-500 text-xs sm:text-sm whitespace-nowrap hidden sm:block font-medium">
                                            4. Contact
                                        </Typography>
                                    </div>
                                </div>

                                {/* Connector line 4 */}
                                <div className="w-4 sm:w-12 md:w-16 h-0.5 bg-red-500 mx-1 sm:mx-2 flex-shrink-0"></div>

                                {/* Step 5 - Error (CURRENT) */}
                                <div className="flex items-center min-w-max relative justify-center">
                                    <div className="relative">
                                        {/* Pulsing ring animation */}
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-red-500 rounded-full animate-ping opacity-20 hidden sm:block"></div>
                                        <div className="absolute inset-0 w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-red-500 rounded-full animate-pulse opacity-30 hidden sm:block"></div>

                                        {/* Main step indicator */}
                                        <div className="relative w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 bg-gradient-to-br from-red-500 to-red-600 text-white rounded-full flex items-center justify-center text-sm sm:text-base md:text-lg font-bold shadow-lg border-2 sm:border-4 border-white flex-shrink-0 z-10">
                                            <XCircle className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6"/>
                                        </div>
                                    </div>

                                    {/* Current step indicator */}
                                    <div className="ml-2 sm:ml-3 hidden sm:block">
                                        <Typography variant="small"
                                                    className="font-bold text-red-600 text-sm sm:text-base whitespace-nowrap">
                                            Error
                                        </Typography>
                                        <div className="text-xs text-red-500 font-medium">
                                            Failed
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-center">
                        <div className="w-full max-w-2xl">
                            <Card className="border-0 shadow-xl bg-white/80 backdrop-blur-sm">
                                <CardBody className="p-6 sm:p-8 lg:p-10">
                                    <div className="flex flex-col items-center text-center">
                                        {/* Error Icon */}
                                        <div className="mb-6 sm:mb-8">
                                            <div className="relative">
                                                {/* Outer glow effect */}
                                                <div className="absolute inset-0 w-20 h-20 sm:w-24 sm:h-24 bg-red-200 rounded-full animate-pulse opacity-50"></div>
                                                <div className="absolute inset-0 w-20 h-20 sm:w-24 sm:h-24 bg-red-300 rounded-full animate-ping opacity-30"></div>

                                                {/* Main error icon */}
                                                <div className="relative w-20 h-20 sm:w-24 sm:h-24 bg-gradient-to-br from-red-400 to-red-600 rounded-full flex items-center justify-center shadow-lg z-10">
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={3}
                                                        stroke="currentColor"
                                                        className="text-white w-10 h-10 sm:w-12 sm:h-12"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M6 18 18 6M6 6l12 12"
                                                        />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Error Message */}
                                        <div className="mb-8 sm:mb-10">
                                            <Typography variant="h3" className="font-bold text-red-600 mb-4">
                                                Reservation Failed!
                                            </Typography>
                                            <Typography variant="h6" color="blue-gray" className="font-semibold mb-6">
                                                We apologize for the inconvenience
                                            </Typography>

                                            {/* Error description */}
                                            <div className="space-y-4">
                                                <div className="p-4 bg-red-50 rounded-lg border border-red-200">
                                                    <Typography className="text-gray-700 font-medium mb-2">
                                                        다른 시간으로 예약을 시도해주시거나, 불편하시더라도 전화로 연락주시면 감사하겠습니다.
                                                    </Typography>
                                                    <Typography className="text-gray-700 font-medium">
                                                        Please try scheduling your appointment for a different time, or feel free to
                                                        give us a call — we'd be happy to assist you.
                                                    </Typography>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Action Button */}
                                        <div className="w-full">
                                            <Button
                                                onClick={handleClick}
                                                variant="gradient"
                                                color="red"
                                                size="lg"
                                                className="w-full font-semibold py-3 px-6 text-white"
                                            >
                                                RETURN HOME
                                            </Button>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
}

export default Error;
